export const Props = () => ({
  //--------------------------------------------------------------------------
  //                              Объект поста Альфы
  //--------------------------------------------------------------------------
  post: {
    type: Object,
    required: true,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
});